/**
 * 3.0 콜랩 상세 문구 — 앱 `locales/en/collab.json` 의 `detailV3` · `threadV3` 를 그대로 옮겼다.
 * @description 웹은 아직 영어 한 벌이라 i18n 계층 없이 상수로 둔다(`search/constants/copy.ts` 와
 *   같은 방침). 키 이름을 앱과 같게 두어 나중에 `t()` 로 갈아끼울 때 자리가 맞는다.
 *
 *   `app` 만 앱에 없는 웹 문구다 — 예전 2.0 웹 상세의 하단 CTA · 작업물 월에 있던 것을 그대로 쓴다.
 *   웹은 참여를 받지 않고 앱으로 보내기 때문이다.
 */
export const COLLAB_V3_COPY = {
  operator: "Provided by Fanwork",
  participants: {
    empty: "No one has joined yet",
    more: (count: number) => ` and ${count} more joined`,
    only: " joined",
    host: "Host",
  },
  schedule: { always: "Join anytime", anytime: "Anytime during the period" },
  location: { online: "Online", fallback: "View place" },
  host: { label: "Hosted by" },
  note: { readMore: "...See more" },
  status: {
    inProgress: "In progress",
    past: "Ended collab",
    cancelled: "Cancelled",
  },
  bar: {
    cancelledNoReason: "This collab was cancelled",
    legacyEnded: "This collab has ended",
  },
  thread: {
    title: "Thread",
    empty: "No updates yet",
    pinned: "Pinned",
    selected: "Picked",
    pickedBy: (name: string) => `${name} picked this`,
    replies: (count: number) =>
      `${count} ${count === 1 ? "reply" : "replies"}`,
    wrapUp: "Wrap-up post",
    execution: "Execution result",
    leftover: "Remaining LS",
    link: {
      unavailable: "This link isn't available",
      /** 바깥 주소(URL)는 이름 대신 도메인을 쓴다 — 앱 링크 줄과 같다 */
      type: {
        COLLAB: "Collab",
        POST: "Post",
        THREAD: "Thread",
        WORK: "Work",
      },
    },
  },
  a11y: {
    share: "Share",
    place: "View place",
    like: "Like",
  },
  app: {
    continueInApp: "Continue in the app",
    seeInApp: "See how it went",
    seeRest: "See the rest in the app",
    openApp: "Open in app",
  },
} as const;
